import { useEffect, useRef, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";

import "./NavbarResponsive.css";

import Link from "../_components/link/Link";

import { HAMBURGER, SIMPLE_LOGO, BLACK_LOGO } from "../_media/assets";
import createAnimation from "../_utils/createAnimation";
import { BOOK_SESSION } from "../_utils/links";

const NavbarResponsive = () => {
  const [isHidden, setIsHidden] = useState(true);
  const ref = useRef(null);
  const navigate = useNavigate();

  useEffect(() => createAnimation(ref), []);

  const active = ({ isActive }) => (isActive ? "active" : "");
  const goHome = () => navigate("/");

  const toggleLinkDisplay = (e) => {
    const { className } = e.target;
    if (
      className === "NavbarResponsive-link-wrapper" ||
      className === "NavbarResponsive-hamburger"
    ) {
      setIsHidden((hidden) => !hidden);
    }
  };

  const close = () => setIsHidden(true);

  return (
    <header className="NavbarResponsive" ref={ref}>
      <nav className="NavbarResponsive-nav">
        <img
          className="NavbarResponsive-hamburger"
          src={HAMBURGER}
          alt="Click for navigation"
          onClick={toggleLinkDisplay}
        />
        <div
          className={`NavbarResponsive-link-wrapper${
            isHidden ? " hidden" : ""
          }`}
          onClick={toggleLinkDisplay}
        >
          <div className={`NavbarResponsive-links${isHidden ? " hidden" : ""}`}>
            <section className="NavbarResponsive-main-links">
              <img className="NavbarResponsive-logo" src={BLACK_LOGO} alt="" />
              <NavLink to="/" className={active} end onClick={close}>Home</NavLink>
              <NavLink to="about-me" className={active} onClick={close}>About Me</NavLink>
              <NavLink to="services" className={active} onClick={close}>Services</NavLink>
            </section>
            <section className="NavbarResponsive-cta">
              <Link primary ariaLabel="Click to book a free session" link={BOOK_SESSION}>
                Book a free session
              </Link>
            </section>
          </div>
        </div>
      </nav>
      <img src={SIMPLE_LOGO} className="NavbarResponsive-small-logo" alt="" onClick={goHome} />
      <Link primary ariaLabel="Click to book a free session" link={BOOK_SESSION}>
        Book a free session
      </Link>
    </header>
  );
};

export default NavbarResponsive;
